/* Every link on the home page, mapped from the v0 prototype's routes onto the
   routes this site actually serves (src/App.js) or, where the site has no
   equivalent, onto the product site that does. Keep this the single place to
   change a destination. */
export const LINKS = {
  home: "/",

  /* Products */
  directRentals: "/rentdirect",
  rentshield: "/rentshield",
  inshur: "/inshurlp",
  renters: "/guest",

  /* Back office */
  onboarding: "https://app.rentid.io/sign-up",
  payments: "https://app.rentid.io/sign-up",
  transitionPlan: "/transition-plan",

  /* Solutions */
  carshare: "/car-sharing",
  rideshare: "/ride-sharing",
  rentalPlatform: "/platform",
  insurancePlatform: "/rentshield",

  /* Resources */
  whyRentid: "/turo-alternative",
  platformOverview: "/features",
  telematics: "https://rentshield.io/telematics",
  apiIntegrations: "https://rentshield.io/api-integration",

  /* Header CTAs — the same targets the existing site header uses. */
  pricing: "/pricing",
  login: "https://app.rentid.io/login",
  bookDemo: "https://api.leadconnectorhq.com/widget/form/xSNa1tu0CCXyei8UJ2ew",
  getStarted: "https://app.rentid.io/sign-up",

  /* Section CTAs */
  whatIsRentid: "/turo-alternative",
  rentid: "/rent-id",
  enterprise: "/enterprise",
};

export const NAV_GROUPS = [
  {
    label: "Products",
    items: [
      { label: "Direct Rentals", href: LINKS.directRentals, description: "Your brand, your bookings" },
      { label: "RentShield", href: LINKS.rentshield, description: "Fleet insurance built in" },
      { label: "INSHUR Coverage", href: LINKS.inshur, description: "Embedded rental protection" },
      { label: "For Renters", href: LINKS.renters, description: "Book from a local host" },
    ],
  },
  {
    label: "Back Office",
    items: [
      { label: "Onboarding", href: LINKS.onboarding, description: "Get your account live" },
      { label: "Payments & Payouts", href: LINKS.payments, description: "Stripe account setup" },
      { label: "Transition Plan", href: LINKS.transitionPlan, description: "Move off the marketplace" },
    ],
  },
  {
    label: "Solutions",
    items: [
      { label: "Carshare", href: LINKS.carshare, description: "Peer-to-peer fleets" },
      { label: "Rideshare", href: LINKS.rideshare, description: "Drivers and gig fleets" },
      { label: "Rental Platform", href: LINKS.rentalPlatform, description: "Full platform coverage" },
      { label: "Insurance Platform", href: LINKS.insurancePlatform, description: "Programs and pricing" },
    ],
  },
  {
    label: "Resources",
    items: [
      { label: "Why Rentid", href: LINKS.whyRentid, description: "The marketplace alternative" },
      { label: "Platform Overview", href: LINKS.platformOverview, description: "How Rentid works" },
      { label: "Telematics", href: LINKS.telematics, description: "Track and protect vehicles" },
      { label: "API & Integrations", href: LINKS.apiIntegrations, description: "Build on Rentid" },
    ],
  },
];

/* RentShield "starting at" figures shown on the home card's pennants. Kept out of
   the markup so the numbers live in one configurable place. */
export const RENTSHIELD_STARTING_AT = {
  offRent: { label: "Off rent", price: "$37", unit: "/vehicle/mo" },
  onRent: { label: "On rent", price: "$16", unit: "/vehicle/day" },
};
